module.exports = __webpack_public_path__ + "img/info-7.76dd1761.svg";